import ReadWriteRecipientViewState from '../store/schema/ReadWriteRecipientViewState';
import ReadWriteRecipientWellViewState from '../store/schema/ReadWriteRecipientWellViewState';
import { action, orchestrator } from 'satcheljs';

const removeRecipientFromRecipientWell = action(
    'removeRecipientFromRecipientWell',
    (
        recipientIndex: number,
        recipientWellRecipients: ReadWriteRecipientWellViewState,
        selectToRight: boolean,
        onRecipientDeletedCallback: (
            removedRecipients: ReadWriteRecipientViewState[],
            indexToRemove: number,
            recipientWellRecipients: ReadWriteRecipientWellViewState,
            selectToRight: boolean
        ) => void
    ) => ({
        recipientIndex: recipientIndex,
        recipientWellRecipients: recipientWellRecipients,
        selectToRight: selectToRight,
        onRecipientDeletedCallback: onRecipientDeletedCallback,
    })
);

export default removeRecipientFromRecipientWell;

orchestrator(removeRecipientFromRecipientWell, actionMessage => {
    actionMessage.recipientWellRecipients.isDirty = true;
    const deletedRecipients: ReadWriteRecipientViewState[] = actionMessage.recipientWellRecipients.recipients.splice(
        actionMessage.recipientIndex,
        1
    );
    actionMessage.onRecipientDeletedCallback(
        deletedRecipients,
        actionMessage.recipientIndex,
        actionMessage.recipientWellRecipients,
        actionMessage.selectToRight
    );
});
